import { $t } from '@/i18n';
import { PROFILE_API_PREFIX } from '@config/constant';
import logger from './logger';
import wujiFetch from './wujiFetch';
export const getComponentHubStoreKey = (registry, group) => `${registry}@${group}`;
const fallbackStoreName = (registry, group) => {
    if (group)
        return group;
    if (registry === 'public')
        return $t('k_7bfb9758');
    return $t('k_db8fa218');
};
const storeInfoMap = {};
// 商店在 DB 里的 id 带 xy_hub_ 前缀，组件信息里的 group 是去掉前缀的部分
const getComponentHubGroupFromId = (id) => {
    const matched = id.match(/^xy_hub_(.+)$/);
    return matched ? matched[1] : '';
};
export const getComponentHubStoreName = (registry, group) => (storeInfoMap[getComponentHubStoreKey(registry, group)]?.name || fallbackStoreName(registry, group));
export const getComponentHubStoreInfo = (registry, group = '') => {
    const id = getComponentHubStoreKey(registry, group);
    const cached = storeInfoMap[id];
    return {
        id,
        name: cached?.name || fallbackStoreName(registry, group),
        ...(cached?.icon ? { icon: cached.icon } : {}),
    };
};
const registerGroups = (registry, groups = []) => {
    groups.forEach((group) => {
        const groupId = getComponentHubGroupFromId(group.id);
        storeInfoMap[getComponentHubStoreKey(registry, groupId)] = {
            name: group.name,
            icon: group.icon,
        };
    });
};
const loadPromises = new Map();
/**
 * 预加载组件商店的展示名与图标，需要在物料包装（componentWrapByUIcore / 可更新模板）之前调用一次
 * 按项目查询：用户不是商店成员、但商店授权给了项目时，也要能拿到商店信息
 */
export const loadComponentHubStores = (projectId) => {
    if (!loadPromises.has(projectId)) {
        const promise = wujiFetch(`${PROFILE_API_PREFIX}/project/${projectId}/groups`)
            .then((res) => {
            registerGroups('local', res.local);
            registerGroups('public', res.public);
        })
            .catch((err) => {
            logger.error($t('k_f3172a27'), err);
            // 移除以便下次调用重试
            loadPromises.delete(projectId);
        });
        loadPromises.set(projectId, promise);
    }
    return loadPromises.get(projectId);
};
